<template>
  <v-label>
    <slot />
  </v-label>
</template>
